import { ShoppingBag, MessageCircle, Truck } from "lucide-react";

const STEPS = [
  {
    id: "scegli",
    icon: ShoppingBag,
    title: "Scegli il capo",
    text: "Guarda la vetrina o le storie Instagram e seleziona ciò che ti piace.",
  },
  {
    id: "scrivi",
    icon: MessageCircle,
    title: "Scrivici su WhatsApp",
    text: "Ti diciamo subito taglia, disponibilità, dettagli tessuto e prezzo reale.",
  },
  {
    id: "spedizione",
    icon: Truck,
    title: "Spedizione a casa",
    text: "Spediamo con corriere veloce in tutta Italia, oppure ritiri in boutique.",
  },
];

export const HowItWorks = () => {
  return (
    <section id="come-funziona" data-testid="how-it-works-section" className="py-24 max-w-6xl mx-auto px-6">
      <div className="text-center max-w-xl mx-auto mb-16">
        <p className="text-xs uppercase tracking-[0.16em] text-cognac font-semibold mb-2">
          Semplice &amp; Diretto
        </p>
        <h2 className="font-display sec-title font-normal text-ink">Come ordinare a distanza</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {STEPS.map((step, i) => (
          <div
            key={step.id}
            data-testid={`step-card-${step.id}`}
            className="p-6 rounded-2xl bg-cream border border-ink/10 space-y-3"
          >
            <div className="flex items-center gap-3">
              <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-bone border border-ink/10 text-cognac">
                <step.icon className="w-5 h-5" aria-hidden="true" />
              </span>
              <span className="font-display text-sm text-ink/50">0{i + 1}</span>
            </div>
            <h3 className="font-display text-xl font-semibold">{step.title}</h3>
            <p className="text-xs text-ink/70 leading-relaxed">{step.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
